/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AudienceOut,
  GetMassMessageAudienceParams,
  HTTPValidationError,
  ListMassMessagesParams,
  MassMessageIn,
  MassMessageOut,
  PaginatedMassMessageOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listMassMessagesResponse200 = {
  data: PaginatedMassMessageOut
  status: 200
}

export type listMassMessagesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listMassMessagesResponseSuccess = (listMassMessagesResponse200) & {
  headers: Headers;
};
export type listMassMessagesResponseError = (listMassMessagesResponse422) & {
  headers: Headers;
};

export type listMassMessagesResponse = (listMassMessagesResponseSuccess | listMassMessagesResponseError)

export const getListMassMessagesUrl = (params?: ListMassMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mass-messages?${stringifiedParams}` : `/api/mass-messages`
}

/**
 * @summary List Mass Messages
 */
export const listMassMessages = async (params?: ListMassMessagesParams, options?: Parameters<typeof apiFetch>[1]): Promise<listMassMessagesResponse> => {

  return apiFetch<listMassMessagesResponse>(getListMassMessagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMassMessagesQueryKey = (params?: ListMassMessagesParams,) => {
    return [
    `/api/mass-messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMassMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listMassMessages>>, TError = HTTPValidationError>(params?: ListMassMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMassMessages>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMassMessagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMassMessages>>> = ({ signal }) => listMassMessages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMassMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMassMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listMassMessages>>>
export type ListMassMessagesQueryError = HTTPValidationError


export function useListMassMessages<TData = Awaited<ReturnType<typeof listMassMessages>>, TError = HTTPValidationError>(
 params: undefined |  ListMassMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMassMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMassMessages>>,
          TError,
          Awaited<ReturnType<typeof listMassMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMassMessages<TData = Awaited<ReturnType<typeof listMassMessages>>, TError = HTTPValidationError>(
 params?: ListMassMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMassMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMassMessages>>,
          TError,
          Awaited<ReturnType<typeof listMassMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMassMessages<TData = Awaited<ReturnType<typeof listMassMessages>>, TError = HTTPValidationError>(
 params?: ListMassMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMassMessages>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Mass Messages
 */

export function useListMassMessages<TData = Awaited<ReturnType<typeof listMassMessages>>, TError = HTTPValidationError>(
 params?: ListMassMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMassMessages>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMassMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createMassMessageResponse201 = {
  data: MassMessageOut
  status: 201
}

export type createMassMessageResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createMassMessageResponseSuccess = (createMassMessageResponse201) & {
  headers: Headers;
};
export type createMassMessageResponseError = (createMassMessageResponse422) & {
  headers: Headers;
};

export type createMassMessageResponse = (createMassMessageResponseSuccess | createMassMessageResponseError)

export const getCreateMassMessageUrl = () => {




  return `/api/mass-messages`
}

/**
 * @summary Create Mass Message
 */
export const createMassMessage = async (massMessageIn: MassMessageIn, options?: Parameters<typeof apiFetch>[1]): Promise<createMassMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createMassMessageResponse>(getCreateMassMessageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(massMessageIn)
  }
);}





export const getCreateMassMessageMutationKey = () => ['createMassMessage'] as const;

export const getCreateMassMessageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMassMessage>>, TError,CreateMassMessageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMassMessage>>, TError,CreateMassMessageMutationVariables, TContext> => {

const mutationKey = getCreateMassMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMassMessage>>, CreateMassMessageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createMassMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMassMessageMutationResult = NonNullable<Awaited<ReturnType<typeof createMassMessage>>>
    export type CreateMassMessageMutationBody = MassMessageIn
    export type CreateMassMessageMutationError = HTTPValidationError
    export type CreateMassMessageMutationVariables = {data: MassMessageIn}

    /**
 * @summary Create Mass Message
 */
export const useCreateMassMessage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMassMessage>>, TError,CreateMassMessageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMassMessage>>,
        TError,
        CreateMassMessageMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMassMessageMutationOptions(options), queryClient);
    }
    export type getMassMessageAudienceResponse200 = {
  data: AudienceOut
  status: 200
}

export type getMassMessageAudienceResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getMassMessageAudienceResponseSuccess = (getMassMessageAudienceResponse200) & {
  headers: Headers;
};
export type getMassMessageAudienceResponseError = (getMassMessageAudienceResponse422) & {
  headers: Headers;
};

export type getMassMessageAudienceResponse = (getMassMessageAudienceResponseSuccess | getMassMessageAudienceResponseError)

export const getGetMassMessageAudienceUrl = (params?: GetMassMessageAudienceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mass-messages/audience?${stringifiedParams}` : `/api/mass-messages/audience`
}

/**
 * @summary Get Mass Message Audience
 */
export const getMassMessageAudience = async (params?: GetMassMessageAudienceParams, options?: Parameters<typeof apiFetch>[1]): Promise<getMassMessageAudienceResponse> => {

  return apiFetch<getMassMessageAudienceResponse>(getGetMassMessageAudienceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMassMessageAudienceQueryKey = (params?: GetMassMessageAudienceParams,) => {
    return [
    `/api/mass-messages/audience`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMassMessageAudienceQueryOptions = <TData = Awaited<ReturnType<typeof getMassMessageAudience>>, TError = HTTPValidationError>(params?: GetMassMessageAudienceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMassMessageAudience>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMassMessageAudienceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMassMessageAudience>>> = ({ signal }) => getMassMessageAudience(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMassMessageAudience>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMassMessageAudienceQueryResult = NonNullable<Awaited<ReturnType<typeof getMassMessageAudience>>>
export type GetMassMessageAudienceQueryError = HTTPValidationError


export function useGetMassMessageAudience<TData = Awaited<ReturnType<typeof getMassMessageAudience>>, TError = HTTPValidationError>(
 params: undefined |  GetMassMessageAudienceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMassMessageAudience>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMassMessageAudience>>,
          TError,
          Awaited<ReturnType<typeof getMassMessageAudience>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMassMessageAudience<TData = Awaited<ReturnType<typeof getMassMessageAudience>>, TError = HTTPValidationError>(
 params?: GetMassMessageAudienceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMassMessageAudience>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMassMessageAudience>>,
          TError,
          Awaited<ReturnType<typeof getMassMessageAudience>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMassMessageAudience<TData = Awaited<ReturnType<typeof getMassMessageAudience>>, TError = HTTPValidationError>(
 params?: GetMassMessageAudienceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMassMessageAudience>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Mass Message Audience
 */

export function useGetMassMessageAudience<TData = Awaited<ReturnType<typeof getMassMessageAudience>>, TError = HTTPValidationError>(
 params?: GetMassMessageAudienceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMassMessageAudience>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMassMessageAudienceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






